import { TaskInstruction } from "pages/project/task/task.typing";
import { hasContent } from "pages/project/common/taskBase/sidebar/instructions/taskInstructionGroups";
import { cn } from "utils/ui";

interface Props {
  instruction: TaskInstruction;
  className?: string;
}

/**
 * Tailwind's preflight strips list markers and paragraph margins, which flattens the WYSIWYG markup
 * authored in Tempo. These classes restore it for the instruction bodies only.
 */
const richTextClassName =
  "min-w-0 max-w-full overflow-x-hidden break-words [overflow-wrap:anywhere] [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:my-0.5 [&_a]:text-ribbon-500 [&_a]:underline [&_strong]:font-semibold [&_em]:italic";

export const InstructionHtmlBody = ({ instruction, className }: Props) => {
  if (hasContent(instruction.formattedText)) {
    return (
      <div
        data-test="instruction-html-body"
        className={cn(richTextClassName, className)}
        dangerouslySetInnerHTML={{ __html: instruction.formattedText }}
      />
    );
  }

  if (hasContent(instruction.description)) {
    return (
      <div data-test="instruction-text-body" className={cn("whitespace-pre-line", className)}>
        {instruction.description}
      </div>
    );
  }

  return null;
};
